export enum MutationTypes {
    SET_LOCATIONS = 'locations-module/set-locations',
    SET_LOCATIONS_META = 'locations-module/set-locations-meta',
    SET_LOCATION = 'locations-module/set-location',
}
